import moment from 'moment-timezone';
import React from 'react';
import {
  StructuredTableColumn,
  StructuredTaskDataTable,
  StructuredTaskSection,
} from '../../../../common/components/StructuredTaskDetails';
import { Resource } from '../../../../common/constants/resource';
import { TRLEmployment } from '../../../tasks/types/trl';
import {
  dateToString,
  NORA_DISPLAY_DATE_FORMAT,
} from '../../utilities/formattingUtilities';

export const RenderEmploymentSection = ({
  employmentHistory,
}: {
  employmentHistory: TRLEmployment[];
}) => {
  const formattedTableData = formatData(employmentHistory);
  const columns: StructuredTableColumn[] = [
    {
      key: Resource.TRL_EMPLOYMENT_EFFECTIVE_KEY,
      label: Resource.TRL_EMPLOYMENT_EFFECTIVE,
    },
    {
      key: Resource.TRL_EMPLOYMENT_EMPLOYER_KEY,
      label: Resource.TRL_EMPLOYMENT_EMPLOYER,
    },
    {
      key: Resource.TRL_EMPLOYMENT_OCCUPATION_KEY,
      label: Resource.TRL_EMPLOYMENT_OCCUPATION,
    },
    {
      key: Resource.TRL_EMPLOYMENT_ON_FILE_SINCE_KEY,
      label: Resource.TRL_EMPLOYMENT_ON_FILE_SINCE,
    },
  ];
  return (
    <StructuredTaskSection title={Resource.TRL_EMPLOYMENT_SUBTITLE}>
      <StructuredTaskDataTable
        columns={columns}
        rows={formattedTableData}
        rowKey={(_, index) => `trl-employment-row-${index}`}
      />
    </StructuredTaskSection>
  );
};

function formatData(employmentHistory: TRLEmployment[]) {
  const formattedTableData = employmentHistory.map(employment => {
    return {
      effective: dateToString(employment.effective),
      employer: employment.employer,
      occupation: employment.occupation,
      onFileSince: dateToString(employment.onFileSince),
    };
  });
  formattedTableData.sort((a, b) =>
    moment(b.effective, NORA_DISPLAY_DATE_FORMAT).diff(
      moment(a.effective, NORA_DISPLAY_DATE_FORMAT),
    ),
  );
  return formattedTableData;
}
